import { render, staticRenderFns } from "./PxNotification.vue?vue&type=template&id=9a9bd9b8&"
import script from "./PxNotification.vue?vue&type=script&lang=js&"
export * from "./PxNotification.vue?vue&type=script&lang=js&"
import style0 from "./PxNotification.vue?vue&type=style&index=0&id=9a9bd9b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports